<mat-chip-listbox [selectable]="false">
  <mat-chip-option
    [matTooltip]="tooltip()"
    [class.configuration-pill__pill--language-template]="templateType() === 'language'"
    [class.configuration-pill__pill--configuration]="templateType() === 'configuration'"
    [class.configuration-pill__pill--industry-pack]="templateType() === 'pack'"
    [class.configuration-pill__pill--configuration-route]="templateType() === 'route'"
    disabled
  >
    @switch (templateType()) {
      @case ('language') {
        LT
      }
      @case ('configuration') {
        CO
      }
      @case ('pack') {
        IP
      }
      @case ('route') {
        CR
      }
    }
  </mat-chip-option>
</mat-chip-listbox>
